import { useState } from 'react'
import Accordion from '../Accordion'

export default function TrekDayByDay({ trek }) {
  const [expandAll, setExpandAll] = useState(false)
  const itinerary = trek.itinerary || []

  return (
    <div style={{ marginBottom: '48px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: '24px' }}>
        <h2 className="section-title" style={{ marginBottom: 0 }}>Day-by-day itinerary.</h2>
        <button
          onClick={() => setExpandAll(e => !e)}
          className="btn"
          style={{ background: 'transparent', border: '1px solid var(--stone-mid)', color: 'var(--ink-mid)', fontSize: '12px' }}
        >
          {expandAll ? 'Collapse all' : 'Expand all'}
        </button>
      </div>

      <Accordion
        items={itinerary}
        exclusive={!expandAll}
        openAll={expandAll}
        defaultOpenIndex={0}
        renderQuestion={item => (
          <span style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <span style={{
              fontSize: '11px', fontWeight: 600, color: 'var(--green)',
              background: 'var(--green-light)', padding: '4px 8px', borderRadius: '4px',
              minWidth: '58px', textAlign: 'center',
            }}>
              DAY {item.day}
            </span>
            <span>{item.title}</span>
            <span style={{ fontSize: '12px', color: 'var(--ink-light)', fontWeight: 400 }}>{item.altitude}</span>
          </span>
        )}
        renderAnswer={item => (
          <>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px', color: 'var(--green)', fontWeight: 600, marginBottom: '8px' }}>
              Walk: {item.walk}
            </div>
            {item.description}
          </>
        )}
      />
    </div>
  )
}
